/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ValidatorService as ɵb} from './lib/components/angular4-material-table/validator.service';
export {PersonValidatorService as ɵa} from './lib/components/custom-fields-editor/custom-fields-editor.component';